import { render, staticRenderFns } from "./merchantsInformation.vue?vue&type=template&id=2b18472b&scoped=true&lang=pug&"
import script from "./merchantsInformation.vue?vue&type=script&lang=js&"
export * from "./merchantsInformation.vue?vue&type=script&lang=js&"
import style0 from "./merchantsInformation.vue?vue&type=style&index=0&id=2b18472b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b18472b",
  null
  
)

export default component.exports